<template>
  <div id="editConsumerInfoModal">
    <CModal
      :show.sync="showModal"
      size="lg"
      :centered="true"
      :closeOnBackdrop="false"
    >
      <CForm>
        <CInput
          label="Name"
          horizontal
          placeholder="Enter name..."
          v-model="formData.name"
          required
          was-validated
        />
        <CInput
          label="Referral code"
          horizontal
          maxlength="20"
          placeholder="Enter referral code..."
          v-model="formData.referral_code"
        />
        <div class="form-row">
          <CCol tag="label" sm="3" class="col-form-label">Affiliate</CCol>
          <CCol sm="9" class="d-flex align-items-center">
            <div class="form-check">
              <input
                id="consumer-is-affiliate"
                v-model="formData.is_affiliate"
                class="form-check-input"
                type="checkbox"
              />
              <label class="form-check-label" for="consumer-is-affiliate">
                Affiliate
              </label>
            </div>
          </CCol>
        </div>
      </CForm>
      <template #header>
        <h5 class="modal-title">Edit Consumer</h5>
        <CButtonClose @click="$emit('close-modal')" />
      </template>
      <template #footer>
        <CButton @click="$emit('close-modal')" color="secondary"
          >Cancel</CButton
        >
        <CButton @click="onUpdateData" color="primary">Save</CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
export default {
  props: {
    showModal: {
      type: Boolean,
      required: true,
      default: false,
    },
    consumerData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      formData: {
        name: '',
        referral_code: '',
        is_affiliate: false,
      },
    };
  },
  watch: {
    showModal: {
      immediate: true,
      handler(isVisible) {
        if (isVisible) {
          this.resetFormData();
        }
      },
    },
    consumerData: {
      deep: true,
      handler() {
        if (this.showModal) {
          this.resetFormData();
        }
      },
    },
  },
  methods: {
    onUpdateData() {
      this.$emit('save', { ...this.formData });
    },
    resetFormData() {
      this.formData = {
        name: this.consumerData.name || '',
        referral_code: this.consumerData.referral_code || '',
        is_affiliate: Boolean(this.consumerData.is_affiliate),
      };
    },
  },
  name: 'EditConsumerInfoModal',
};
</script>
